import { useBaseMask } from '../hooks/useBaseMask'
import { useNumericMask } from '../hooks/useNumeric'
import { usePattern } from '../hooks/usePattern'
import {
  InputAttributes,
  OnValueChange,
  PatternFormatProps,
  PresetFormatProps,
} from '../hooks/utils/types'
import { COUNTRIES_MASKS, ICountriesKeys } from './constatns'
import {
  cardExpiry,
  currency,
  date,
  dateRange,
  stringWithSpaces,
} from './templates'

export const usePatternMask = usePattern

export const useCardExpiryMask = (props?: PresetFormatProps) => {
  return useBaseMask({
    ...cardExpiry,
    ...props,
  })
}

export const useStringWithSpacesMask = (props?: PresetFormatProps) => {
  return useBaseMask({
    ...stringWithSpaces,
    ...props,
  })
}

export const useCurrencyMask = (props?: PresetFormatProps) => {
  return useNumericMask({
    ...currency,
    ...props,
  })
}

type IProps = {
  value?: number | string | null
  defaultValue?: number | string | null
  onValueChange?: OnValueChange
  onKeyDown?: InputAttributes['onKeyDown']
  onMouseUp?: InputAttributes['onMouseUp']
  onChange?: InputAttributes['onChange']
  onFocus?: InputAttributes['onFocus']
  onBlur?: InputAttributes['onBlur']
  onPaste?: InputAttributes['onPaste']
}
interface IPhoneMask {
  mask: IProps
  country: ICountriesKeys
}

export const usePhoneMask = (props: IPhoneMask) => {
  const { mask, country } = props

  const format = COUNTRIES_MASKS[country]
  const maskProps: PatternFormatProps = {
    ...mask,
    format: format,
  }
  return usePattern({
    ...maskProps,
    mask: '_',
  })
}

export const useIBANMask = (props: IProps) => {
  const maskProps: PatternFormatProps = {
    ...props,
    format: 'KZdddddddddddddddddd',
  }
  return usePattern({
    ...maskProps,
    mask: '_',
  })
}
